import { render, staticRenderFns } from "./PrivilegeSet.vue?vue&type=template&id=816d1478&scoped=true"
import script from "./PrivilegeSet.vue?vue&type=script&lang=js"
export * from "./PrivilegeSet.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeSet.vue?vue&type=style&index=0&id=816d1478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816d1478",
  null
  
)

export default component.exports